/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Ai_ReadyInputs */

const cs_blog_ai_ready = /** @type {(inputs: Blog_Ai_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI dokončila — obsah byl aktualizován`)
};

const en_blog_ai_ready = /** @type {(inputs: Blog_Ai_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI finished — content updated`)
};

/**
* | output |
* | --- |
* | "AI finished — content updated" |
*
* @param {Blog_Ai_ReadyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_ai_ready = /** @type {((inputs?: Blog_Ai_ReadyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Ai_ReadyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_ai_ready(inputs)
	return cs_blog_ai_ready(inputs)
});